import React, { useContext, useState, useCallback } from 'react';
import { Collapsible } from 'src/components/collapsible';
import { AppContext } from 'src/components/app-context';
import { ScrollElement } from 'src/components/scroll';

import Banner from '../banner';
import AdContainer from '../../../../components/ads';
import { useViewportContext } from 'src/components/viewport/context';

import * as S from './styles';
import type { CampaignPageQuery } from 'src/types';

interface CampaignHeaderProps {
  campaign?: CampaignPageQuery['campaign'] | null;
  isActive: boolean;
}

const CampaignHeader: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<CampaignHeaderProps>>
> = props => {
  const { renderMode, t } = useContext(AppContext);
  const { isMobile, isTablet } = useViewportContext();
  const shouldCollapseDescription = isMobile || isTablet;
  const [descriptionCollapsed, setDescriptionCollapsed] = useState(
    shouldCollapseDescription
  );
  const expandDescription = useCallback(
    () => setDescriptionCollapsed(false),
    []
  );
  const isCollapsed = shouldCollapseDescription && descriptionCollapsed;

  return props.campaign ? (
    <S.Header>
      <S.Container>
        <S.LogoAndText>
          <S.Logo>
            <Banner
              banners={props.campaign.banners}
              type="banner_logo_big"
              alt={props.campaign.title?.page}
            />
          </S.Logo>
          <S.Content>
            <S.Title data-test="CampaignHeaderTitle">
              {props.campaign.facetted?.title}
            </S.Title>
            <Collapsible
              collapsed={isCollapsed}
              expandText={t('symbols', 'symbol.expand')}
              onExpand={expandDescription}
            >
              <p
                data-test="CampaignHeaderDescription"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: props.campaign.facetted?.description ?? '',
                }}
              />
            </Collapsible>
          </S.Content>
        </S.LogoAndText>
        {renderMode === 'desktop' && (
          <AdContainer
            format="insider_1"
            placement="small_insider_1"
            min={640}
            max={10000}
          />
        )}
      </S.Container>
      <S.Ads>
        <ScrollElement name="CampaignHeaderAd">
          <AdContainer
            format="panorama_1"
            placement="dubbelpanorama1"
            min={0}
            max={639}
          />
        </ScrollElement>
      </S.Ads>
    </S.Header>
  ) : null;
};

export default CampaignHeader;
